// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 179) return "gallery/main.3ab304bd.css";
	// return url for filenames based on template
	return "gallery/" + chunkId + "." + {"654":"1564c9e3","718":"4c509ddd"}[chunkId] + ".css";
};